import { WindowTitle } from "@saleor/components/WindowTitle";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { commonMessages } from "@saleor/intl";
import { SiteLanguageUpdate } from "@saleor/siteLanguages/types/SiteLanguageUpdate";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { SiteLanguageInput } from "../../../types/globalTypes";
import SiteLanguageDetailsPage, {
  SiteLanguageDetailPageFormData
} from "../../components/SiteLanguageDetailPage";
import { TypedSiteLanguageUpdate } from "../../mutations";
import { TypedSiteLanguageDetailsQuery } from "../../queries";
import {
  siteLanguageListUrl,
  SiteLanguageListUrlQueryParams
} from "../../urls";

export interface SiteLanguageDetailsProps {
  id: string;
  params: SiteLanguageListUrlQueryParams;
}

const createSiteLanguageInput = (
  data: SiteLanguageDetailPageFormData
): SiteLanguageInput => ({
  name: data.name,
  domain: data.domain,
  language: data.language,
  isActive: data.isActive,
  checkoutPopupImage: data.checkoutPopupImage
});

export const SiteLanguageDetails: React.FC<SiteLanguageDetailsProps> = ({
  id
}) => {
  const navigate = useNavigator();
  const intl = useIntl();
  const notify = useNotifier();
  const handleMessage = (data: SiteLanguageUpdate) => {
    if (data.siteLanguageUpdate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
    }
  };
  return (
    <TypedSiteLanguageUpdate onCompleted={handleMessage}>
      {(siteLanguageUpdate, pageUpdateOpts) => (
        <TypedSiteLanguageDetailsQuery variables={{ id }}>
          {siteLanguageDetails => {
            const handleUpdate = async (
              data: SiteLanguageDetailPageFormData
            ) => {
              const result = await siteLanguageUpdate({
                variables: {
                  id,
                  input: createSiteLanguageInput(data)
                }
              });

              return result.data.siteLanguageUpdate.errors;
            };

            return (
              <>
                <WindowTitle
                  title={maybe(
                    () => siteLanguageDetails.data.siteLanguage.name
                  )}
                />
                <SiteLanguageDetailsPage
                  disabled={siteLanguageDetails.loading}
                  errors={pageUpdateOpts.data?.siteLanguageUpdate.errors || []}
                  saveButtonBarState={pageUpdateOpts.status}
                  siteLanguage={siteLanguageDetails.data?.siteLanguage}
                  onBack={() => navigate(siteLanguageListUrl())}
                  onRemove={undefined}
                  onSubmit={handleUpdate}
                />
              </>
            );
          }}
        </TypedSiteLanguageDetailsQuery>
      )}
    </TypedSiteLanguageUpdate>
  );
};
SiteLanguageDetails.displayName = "SiteLanguageDetails";
export default SiteLanguageDetails;
